import styled, { css } from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';

type UserAvatarProps = {
  size: number;
  hasAvatar: boolean;
  isLoggedIn: boolean;
};

export const UserAvatar = styled.div<UserAvatarProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: ${p => Math.round(0.67 * p.size)}px;
  text-transform: uppercase;
  height: ${p => p.size}px;
  width: ${p => p.size}px;
  border-radius: ${p => p.size}px;
  color: ${colors.lightTheme.base500};
  transition: all ${layout.animations.buttonTransition};
  overflow: hidden;

  img {
    transition: all ${layout.animations.buttonTransition};
    border-radius: ${p => p.size}px;

    &:hover {
      filter: brightness(80%);
    }
  }

  &:hover,
  /* UserAvatar isn't interactive itself, so we need to style its
    interactive state based on whether it's inside a focused element */
  .focus-visible & {
    cursor: pointer;
    color: ${p => p.theme.icons.callToActionHover};
  }

  ${p =>
    p.isLoggedIn &&
    !p.hasAvatar &&
    css`
      background: ${colors.lightTheme.base500};
      color: ${colors.white};

      &:hover,
      .focus-visible & {
        color: ${colors.white};
        background: ${p.theme.icons.callToActionHover};
      }
    `};
`;
